import { SxProps } from '@mui/material';

export const kitSX: Record<string, SxProps> = {
	container: {
		display: 'flex',
		width: '100%',
		gap: '10px',
		flexDirection: { xs: 'column', md: 'row' },
	},
	leftContainer: {
		width: { xs: '100%', md: '50%' },
	},
	gallery: {
		overflow: 'unset',
	},
	rightContainer: {
		width: { xs: '100%', md: '50%' },
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
	},
	paperName: {
		p: 0,
		m: 0,
	},
	paperPrice: {
		p: { xs: '10px', md: '20px' },
		m: 0,
	},
	paperTitle: {
		color: 'grey.500',
	},
};
